module.exports = __webpack_public_path__ + "img/Survey-Form-MediPro+Income-Protection.3cf7ce3f.png";